import { memo } from 'react';
import { baseHeaderStyle } from '../../assets/styles/StationDataTable.styles';

interface DayHeaderProps {
  timestamp: string;
  groupInterval?: '1' | '3' | '6' | '12' | '24';
}

const DayHeader = memo(({ timestamp, groupInterval }: DayHeaderProps) => {
  // Extract date components from ISO string
  const year = parseInt(timestamp.substring(0, 4));
  const month = parseInt(timestamp.substring(5, 7)) - 1;
  const day = parseInt(timestamp.substring(8, 10));
  const hour = parseInt(timestamp.substring(11, 13));
  
  // Calculate day of week (0 = Sunday, 1 = Monday, etc.)
  const date = new Date(year, month, day);
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  const dayOfWeek = days[date.getDay()];
  
  // Format hour
  const ampm = hour >= 12 ? 'pm' : 'am';
  const hour12 = hour % 12 || 12;
  
  return (
    <div>
      <div style={baseHeaderStyle}>{dayOfWeek}</div>
      {groupInterval === '24' ? (
        <div>
          <div>{`${month + 1}/${day}`}</div>
        </div>
      ) : (
        <div>
          <div>{`${hour12}${ampm}`}</div>
        </div>
      )}
    </div>
  );
}, (prevProps, nextProps) => 
  prevProps.timestamp === nextProps.timestamp &&
  prevProps.groupInterval === nextProps.groupInterval
);

export default DayHeader;
